/* cc-currency.js (jQuery) — Minimog + Cart + Subify + Easify/Cartmax
   Base: AED | Geo: AE/GB/CA/TR/SA/US | Daily USD-based rates | Header selector support
   + Flags (SVG) + Custom dropdown with flags
   ✅ Fix: Cartmax 2nd product variant price via /products/<handle>.js fallback
   ✅ Fix: Bundle discount remains (Save X% applied to base cents)
   ✅ Fix: No drift/0.xx bug (never parse base from non-AED text)
   ✅ FIX: Multi header (desktop+mobile) no duplicate, all synced, per-wrap UI
   ✅ FIX (ONLY): Product card compare-at price should NOT become discounted (locks original compare cents)
*/
(function ($) {
  if (!window.jQuery) return;

  var BASE = "AED";

  var COUNTRY_TO_CURRENCY = { AE: "AED", GB: "GBP", CA: "CAD", TR: "TRY", SA: "SAR", US: "USD" };
  var SYMBOL = { AED: "AED", GBP: "£", CAD: "CA$", TRY: "₺", SAR: "SAR", USD: "$" };

  var FLAG_SVG = {
    AED:
      '<svg viewBox="0 0 640 480" width="22" height="16" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg">' +
      '<rect width="640" height="480" fill="#00732f"/><rect y="160" width="640" height="320" fill="#fff"/>' +
      '<rect y="320" width="640" height="160" fill="#000"/><rect width="213" height="480" fill="#ce1126"/></svg>',
    GBP:
      '<svg viewBox="0 0 640 480" width="22" height="16" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg">' +
      '<rect width="640" height="480" fill="#012169"/><path d="M0 0L640 480M640 0L0 480" stroke="#fff" stroke-width="96"/>' +
      '<path d="M0 0L640 480M640 0L0 480" stroke="#C8102E" stroke-width="64"/><rect x="272" width="96" height="480" fill="#fff"/>' +
      '<rect y="192" width="640" height="96" fill="#fff"/><rect x="288" width="64" height="480" fill="#C8102E"/><rect y="208" width="640" height="64" fill="#C8102E"/></svg>',
    CAD:
      '<svg viewBox="0 0 640 480" width="22" height="16" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg">' +
      '<rect width="640" height="480" fill="#fff"/><rect width="160" height="480" fill="#d52b1e"/><rect x="480" width="160" height="480" fill="#d52b1e"/>' +
      '<path fill="#d52b1e" d="M320 120l-20 60-60-20 40 50-40 50 60-20 20 60 20-60 60 20-40-50 40-50-60 20z"/></svg>',
    TRY:
      '<svg viewBox="0 0 640 480" width="22" height="16" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg">' +
      '<rect width="640" height="480" fill="#e30a17"/><circle cx="280" cy="240" r="100" fill="#fff"/><circle cx="305" cy="240" r="80" fill="#e30a17"/>' +
      '<polygon fill="#fff" points="360,240 430,270 405,200 455,160 390,160"/></svg>',
    SAR:
      '<svg viewBox="0 0 640 480" width="22" height="16" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg">' +
      '<rect width="640" height="480" fill="#006c35"/><rect x="160" y="300" width="320" height="20" fill="#fff"/></svg>',
    USD:
      '<svg viewBox="0 0 640 480" width="22" height="16" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg">' +
      '<rect width="640" height="480" fill="#b22234"/><g fill="#fff"><rect y="40" width="640" height="40"/><rect y="120" width="640" height="40"/>' +
      '<rect y="200" width="640" height="40"/><rect y="280" width="640" height="40"/><rect y="360" width="640" height="40"/><rect y="440" width="640" height="40"/></g>' +
      '<rect width="280" height="280" fill="#3c3b6e"/></svg>',
  };

  var STORAGE_KEY = "cc_currency";
  var RATES_KEY = "cc_rates_usd";
  var RATES_TS_KEY = "cc_rates_ts";

  var RATES_URL = "https://open.er-api.com/v6/latest/USD";
  var GEO_URL = "https://ipapi.co/json/";
  var ONE_DAY = 24 * 60 * 60 * 1000;

  var observer = null;
  var debounceTimer = null;
  var isUpdating = false;
  var usdRatesCache = null;

  var productJsCache = {}; // handle -> product json OR promise

  function safeJsonParse(s) { try { return JSON.parse(s); } catch (e) { return null; } }
  function getSavedCurrency() { return localStorage.getItem(STORAGE_KEY); }
  function saveCurrency(cur) { localStorage.setItem(STORAGE_KEY, cur); document.documentElement.setAttribute("data-cc-currency", cur); }

  function ajaxJson(url, timeoutMs) {
    return $.ajax({ url: url, method: "GET", dataType: "json", timeout: timeoutMs || 6000 });
  }

  function getGeoCurrency() {
    return ajaxJson(GEO_URL, 5000)
      .then(function (data) {
        var cc = data && data.country_code ? String(data.country_code).toUpperCase() : null;
        return (cc && COUNTRY_TO_CURRENCY[cc]) ? COUNTRY_TO_CURRENCY[cc] : BASE;
      })
      .catch(function () { return BASE; });
  }

  function getUsdRates() {
    var cached = safeJsonParse(localStorage.getItem(RATES_KEY));
    var ts = Number(localStorage.getItem(RATES_TS_KEY) || "0");
    if (cached && cached.rates && (Date.now() - ts) < ONE_DAY) return $.Deferred().resolve(cached).promise();

    return ajaxJson(RATES_URL, 6000).then(function (data) {
      localStorage.setItem(RATES_KEY, JSON.stringify(data));
      localStorage.setItem(RATES_TS_KEY, String(Date.now()));
      return data;
    });
  }

  function formatMoney(amountNumber, currency) {
    var symbol = SYMBOL[currency] || currency;
    var n = Number(amountNumber);
    if (!isFinite(n)) n = 0;
    var fixed = n.toFixed(2);
    var parts = fixed.split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return symbol + " " + parts.join(".");
  }

  function convertFromAedCents(baseCentsAed, usdRates, targetCurrency) {
    var rates = (usdRates && usdRates.rates) ? usdRates.rates : {};
    var rateAed = rates[BASE];
    var rateTarget = rates[targetCurrency];
    if (!rateAed || !rateTarget) return null;
    return (baseCentsAed / 100) * (rateTarget / rateAed);
  }

  function normalizeToCentsFromText(text) {
    var str = String(text || "").replace(/,/g, "");
    var m = str.match(/([0-9]+(\.[0-9]{1,2})?)/);
    if (!m || !m[1]) return null;
    var amount = Number(m[1]);
    if (!isFinite(amount)) return null;
    return Math.round(amount * 100);
  }

  function textLooksLikeAed(text) { return /AED/i.test(String(text || "")); }
  function formatAedTextFromCents(cents) { return "AED " + (Number(cents || 0) / 100).toFixed(2); }

  // =========================
  // ✅ ONLY FIX: Compare-at lock
  // =========================
  function isCompareEl(el) {
    if (!el) return false;
    var tag = (el.tagName || "").toLowerCase();
    if (tag === "s" || tag === "del") return true;

    var cls = " " + String(el.className || "").toLowerCase() + " ";
    return (
      cls.indexOf("compare") > -1 ||
      cls.indexOf("was") > -1 ||
      cls.indexOf("strike") > -1 ||
      cls.indexOf("old") > -1
    );
  }

  // Capture original AED cents ONCE per element (used to keep compare-at original)
  function captureOriginalAedCentsOnce() {
    $(".cc-price").each(function () {
      var el = this;
      if (el.getAttribute("data-cc-orig-cents")) return;

      var txt = (el.textContent || "").trim();
      if (!txt) return;

      // only trust AED text as original base
      if (!textLooksLikeAed(txt)) return;

      var cents = normalizeToCentsFromText(txt);
      if (!isFinite(cents) || cents <= 0) return;

      el.setAttribute("data-cc-orig-cents", String(cents));
    });
  }

  // ✅ FIX 1: Update header flag + active code in ALL wrappers (desktop + mobile)
  function updateHeaderFlag(currency) {
    $(".cc-currency-wrap").each(function () {
      var $wrap = $(this);

      var $flag = $wrap.find("[data-cc-flag]");
      if (!$flag.length) $flag = $wrap.find("#ccHeaderFlag");

      var $code = $wrap.find("[data-cc-code]");
      if (!$code.length) $code = $wrap.find("#ccActiveCode");

      if ($flag.length) $flag.html(FLAG_SVG[currency] || "");
      if ($code.length) $code.text(currency);
    });
  }

  // ✅ FIX 2: Custom dropdown per wrapper + no duplicate items
  function initCurrencyUI() {
    $(".cc-currency-wrap").each(function () {
      var $wrap = $(this);

      var $sel = $wrap.find("[data-cc-selector]");
      if (!$sel.length) $sel = $wrap.find("#ccCurrency");

      var $ui = $wrap.find("[data-cc-ui]");
      if (!$ui.length) $ui = $wrap.find("#ccCurrencyUI");

      var $list = $wrap.find("[data-cc-list]");
      if (!$list.length) $list = $wrap.find("#ccCurrencyList");

      if (!$sel.length || !$ui.length || !$list.length) return;

      function setExpanded(val) { $ui.attr("aria-expanded", val ? "true" : "false"); }
      function closeList() { $list.prop("hidden", true); setExpanded(false); }

      if (!$wrap.data("cc-built")) {
        $list.empty();

        $sel.find("option").each(function () {
          var cur = String(this.value || "").trim();
          if (!cur) return;

          var $btn = $('<button type="button" class="cc-currency-item" role="option"></button>');
          $btn.append('<span class="cc-flag-item" aria-hidden="true">' + (FLAG_SVG[cur] || "") + "</span>");
          $btn.append('<span class="cc-code-item">' + cur + "</span>");

          $btn.on("click", function (e) {
            e.preventDefault(); e.stopPropagation();
            $sel.val(cur).trigger("change.cc");
            closeList();
          });

          $list.append($btn);
        });

        $wrap.data("cc-built", true);
      }

      $ui.off("click.ccui").on("click.ccui", function (e) {
        e.preventDefault(); e.stopPropagation();

        $(".cc-currency-wrap").not($wrap).find("[data-cc-list],#ccCurrencyList").prop("hidden", true);
        $(".cc-currency-wrap").not($wrap).find("[data-cc-ui],#ccCurrencyUI").attr("aria-expanded", "false");

        var isHidden = $list.prop("hidden");
        $list.prop("hidden", !isHidden);
        setExpanded(isHidden);
      });
    });

    if (!$(document).data("ccui-global")) {
      $(document).data("ccui-global", true);

      $(document).on("click.ccuiGlobal", function (e) {
        if (!$(e.target).closest(".cc-currency-wrap").length) {
          $(".cc-currency-wrap").find("[data-cc-list],#ccCurrencyList").prop("hidden", true);
          $(".cc-currency-wrap").find("[data-cc-ui],#ccCurrencyUI").attr("aria-expanded", "false");
        }
      });

      $(document).on("keydown.ccuiGlobal", function (e) {
        if (e.key === "Escape") {
          $(".cc-currency-wrap").find("[data-cc-list],#ccCurrencyList").prop("hidden", true);
          $(".cc-currency-wrap").find("[data-cc-ui],#ccCurrencyUI").attr("aria-expanded", "false");
        }
      });
    }
  }

  // ----- Subify -----
  function convertSubifyTextNode($el, currency) {
    var baseCents = Number($el.attr("data-cc-base-cents"));
    if (!isFinite(baseCents) || baseCents <= 0) {
      var parsed = normalizeToCentsFromText($el.text());
      if (!isFinite(parsed) || parsed <= 0) return;
      baseCents = parsed;
      $el.attr("data-cc-base-cents", baseCents);
    }
    if (currency === BASE) { $el.text(formatMoney(baseCents / 100, BASE)); return; }
    var converted = convertFromAedCents(baseCents, usdRatesCache, currency);
    if (converted == null) return;
    $el.text(formatMoney(converted, currency));
  }

  // ----- Subify Discount Placement-----
  
  // ----- shadow helpers -----
  function walkShadowRoots(rootNode, cb) {
    if (!rootNode) return;
    cb(rootNode);
    var all = rootNode.querySelectorAll ? rootNode.querySelectorAll("*") : [];
    for (var i = 0; i < all.length; i++) {
      var n = all[i];
      if (n && n.shadowRoot) walkShadowRoots(n.shadowRoot, cb);
    }
  }

  function convertShadowPriceEl(el, currency, opts) {
    if (!el) return;
    var rawText = (el.textContent || "").trim();
    if (!rawText) return;

    if (textLooksLikeAed(rawText)) {
      var parsed = normalizeToCentsFromText(rawText);
      if (isFinite(parsed) && parsed > 0) el.setAttribute("data-cc-base-cents", String(parsed));
    }

    var baseCents = Number(el.getAttribute("data-cc-base-cents") || "0");
    if (!isFinite(baseCents) || baseCents <= 0) return;

    var isTotalLine = (opts && opts.isTotalLine) === true;
    var prefix = (opts && opts.prefixText) ? opts.prefixText : "";
    var suffix = (opts && opts.suffixText) ? opts.suffixText : "";

    if (currency === BASE) {
      if (isTotalLine) el.textContent = prefix + (baseCents / 100).toFixed(2) + " " + BASE + suffix;
      else el.textContent = formatMoney(baseCents / 100, BASE);
      return;
    }

    var conv = convertFromAedCents(baseCents, usdRatesCache, currency);
    if (conv == null) return;
    el.textContent = isTotalLine ? (prefix + formatMoney(conv, currency) + suffix) : formatMoney(conv, currency);
  }

  function updateEasifyCartmaxPrices(currency) {
    var hosts = document.querySelectorAll(
      "cartmax-product-recommend, checkbok-card, cartmax-card, cartmax-select, cartmax-button, cartmax-image, cartmax-checkbox, cartmax-tag"
    );

    for (var i = 0; i < hosts.length; i++) {
      var h = hosts[i];
      if (!h || !h.shadowRoot) continue;

      walkShadowRoots(h.shadowRoot, function (sr) {
        var priceEls = sr.querySelectorAll(".cartmax-card-content-left-content-text-price-amount");
        for (var a = 0; a < priceEls.length; a++) convertShadowPriceEl(priceEls[a], currency);

        var compareEls = sr.querySelectorAll(".cartmax-card-content-left-content-text-price-line");
        for (var b = 0; b < compareEls.length; b++) convertShadowPriceEl(compareEls[b], currency);

        var totals = sr.querySelectorAll(".footer-total");
        for (var c = 0; c < totals.length; c++) {
          var prefix = document.body.classList.contains("is-ar") ? "الإجمالي: " : "Total: ";
          convertShadowPriceEl(totals[c], currency, { isTotalLine: true, prefixText: prefix });
        }
      });
    }
  }

  function recomputeCartmaxTotalInSameShadow(shadowRoot) {
    if (!shadowRoot) return;
    var totalCents = 0;
    var rows = shadowRoot.querySelectorAll(".cartmax-list-check");

    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      var cb = row.querySelector('input[type="checkbox"]');
      var isChecked = cb ? cb.checked : true;
      if (!isChecked) continue;

      var priceEl = row.querySelector(".cartmax-card-content-left-content-text-price-amount");
      if (!priceEl) continue;

      var cents = Number(priceEl.getAttribute("data-cc-base-cents") || "0");
      if (!isFinite(cents) || cents <= 0) continue;

      totalCents += cents;
    }

    var footerTotal = shadowRoot.querySelector(".footer-total");
    if (!footerTotal) return;

    footerTotal.setAttribute("data-cc-base-cents", String(totalCents));

    var cur = getSavedCurrency() || BASE;
    if (cur === BASE) {
      var prefix = document.body.classList.contains("is-ar") ? "الإجمالي: " : "Total: ";
      footerTotal.textContent = prefix + (totalCents / 100).toFixed(2) + " " + BASE;
    }
  }

  function getBundleDiscountPercentFromShadow(shadowRoot) {
    if (!shadowRoot) return 0;
    var el = shadowRoot.querySelector(".cart-card-tag-content, .footer-dis");
    var txt = el ? (el.textContent || "") : "";
    var m = String(txt).match(/(\d+)\s*%/);
    var pct = m ? Number(m[1]) : 0;
    if (!isFinite(pct) || pct < 0 || pct > 90) return 0;
    return pct;
  }

  function extractHandleFromCard(card) {
    if (!card || !card.querySelector) return null;
    var a = card.querySelector('a[href*="/products/"]');
    if (!a) return null;
    var href = a.getAttribute("href") || "";
    var m = href.match(/\/products\/([^/?#]+)/i);
    return m ? m[1] : null;
  }

  function fetchProductJsByHandle(handle) {
    handle = String(handle || "").trim();
    if (!handle) return $.Deferred().reject().promise();

    var cached = productJsCache[handle];
    if (cached) {
      if (cached.variants) return $.Deferred().resolve(cached).promise();
      return cached;
    }

    var p = ajaxJson("/products/" + encodeURIComponent(handle) + ".js", 8000)
      .then(function (data) { productJsCache[handle] = data; return data; })
      .catch(function () { delete productJsCache[handle]; throw new Error("product.js fetch failed"); });

    productJsCache[handle] = p;
    return p;
  }

  function extractVariantIdFromGid(gid) {
    var m = String(gid || "").match(/(\d+)\s*$/);
    return m ? m[1] : null;
  }

  function setCartmaxCardBasePriceFromCartmaxSelectHost(cartmaxSelectHost) {
    if (!cartmaxSelectHost || !cartmaxSelectHost.shadowRoot) return;

    var sr = cartmaxSelectHost.shadowRoot;
    var selectEl = sr.querySelector("select");
    if (!selectEl) return;

    var gid = selectEl.value || "";
    var vidStr = extractVariantIdFromGid(gid);
    if (!vidStr) return;

    var vid = Number(vidStr);
    if (!isFinite(vid)) return;

    var card = cartmaxSelectHost.closest && cartmaxSelectHost.closest(".cartmax-list-check");
    if (!card) return;

    var root = card.getRootNode && card.getRootNode();
    var discountPct = getBundleDiscountPercentFromShadow(root);

    function applyCentsToCard(originalCents) {
      originalCents = Number(originalCents);
      if (!isFinite(originalCents) || originalCents <= 0) return;

      var discountedCents = (discountPct > 0) ? Math.round(originalCents * (100 - discountPct) / 100) : originalCents;

      var priceEl = card.querySelector(".cartmax-card-content-left-content-text-price-amount");
      if (priceEl) {
        priceEl.setAttribute("data-cc-base-cents", String(discountedCents));
        if ((getSavedCurrency() || BASE) === BASE) priceEl.textContent = formatAedTextFromCents(discountedCents);
      }

      var compareEl = card.querySelector(".cartmax-card-content-left-content-text-price-line");
      if (compareEl) {
        if (discountPct > 0) {
          compareEl.style.display = "";
          compareEl.setAttribute("data-cc-base-cents", String(originalCents));
          if ((getSavedCurrency() || BASE) === BASE) compareEl.textContent = formatAedTextFromCents(originalCents);
        }
      }

      if (root && root.querySelector) recomputeCartmaxTotalInSameShadow(root);
      setTimeout(forceUpdateNow, 0);
      setTimeout(forceUpdateNow, 120);
      setTimeout(forceUpdateNow, 350);
    }

    try {
      for (var k in window) {
        if (!Object.prototype.hasOwnProperty.call(window, k)) continue;
        if (k.indexOf("cartmax_product_") !== 0) continue;
        var obj = window[k];
        var p = obj && obj.product ? obj.product : null;
        if (!p || !p.variants) continue;

        for (var i = 0; i < p.variants.length; i++) {
          if (Number(p.variants[i].id) === vid) {
            applyCentsToCard(Number(p.variants[i].price));
            return;
          }
        }
      }
    } catch (e) {}

    var handle = extractHandleFromCard(card);
    if (!handle) return;

    fetchProductJsByHandle(handle).then(function (prod) {
      if (!prod || !prod.variants) return;
      for (var i = 0; i < prod.variants.length; i++) {
        if (Number(prod.variants[i].id) === vid) {
          applyCentsToCard(Number(prod.variants[i].price));
          return;
        }
      }
    }).catch(function(){});
  }

  function bindCartmaxVariantHook() {
    function findCartmaxSelectHostFromEvent(e) {
      if (!e) return null;
      if (e.target && e.target.tagName === "CARTMAX-SELECT") return e.target;
      if (typeof e.composedPath === "function") {
        var path = e.composedPath();
        for (var i = 0; i < path.length; i++) {
          var n = path[i];
          if (n && n.tagName === "CARTMAX-SELECT") return n;
        }
      }
      return null;
    }

    document.addEventListener("change", function (e) {
      var host = findCartmaxSelectHostFromEvent(e);
      if (!host) return;
      try { setCartmaxCardBasePriceFromCartmaxSelectHost(host); } catch (err) {}
    }, true);

    document.addEventListener("input", function (e) {
      var host = findCartmaxSelectHostFromEvent(e);
      if (!host) return;
      try { setCartmaxCardBasePriceFromCartmaxSelectHost(host); } catch (err) {}
    }, true);
  }

  function updateAllPrices(currency) {
    if (!usdRatesCache) return;
    if (isUpdating) return;

    isUpdating = true;
    try {
      // ✅ ONLY FIX: snapshot original AED cents (so compare-at stays original)
      captureOriginalAedCentsOnce();

      $(".cc-price[data-cc-base-cents]").each(function () {
        // ✅ ONLY FIX: if this element is compare-at, always lock it to original cents
        if (isCompareEl(this)) {
          var orig = Number(this.getAttribute("data-cc-orig-cents") || "0");
          if (isFinite(orig) && orig > 0) {
            $(this).attr("data-cc-base-cents", String(orig));
          }
        }

        var $el = $(this);
        var cents = Number($el.attr("data-cc-base-cents") || "0");
        if (!isFinite(cents) || cents <= 0) return;

        if (currency === BASE) { $el.text(formatMoney(cents / 100, BASE)); return; }
        var conv = convertFromAedCents(cents, usdRatesCache, currency);
        if (conv == null) return;
        $el.text(formatMoney(conv, currency));
      });

      // $(".subify-choice-price").each(function () {
      //   convertSubifyTextNode($(this), currency);
      // });
      // // ✅ NEW: Subify selling plan price convert
      // $(".subify-selling-plan-price").each(function () {
      //   convertSubifyTextNode($(this), currency);
      // });

      // ✅ NEW Subify Minimal Widget Support
      $(".subify-minimal-price, .subify-minimal-original-price").each(function () {
        convertSubifyTextNode($(this), currency);
      });

      updateEasifyCartmaxPrices(currency);
    } finally {
      isUpdating = false;
    }
  }

  function forceUpdateNow() {
    if (!usdRatesCache) return;
    updateAllPrices(getSavedCurrency() || BASE);
  }

  function scheduleUpdate() {
    if (debounceTimer) return;
    debounceTimer = setTimeout(function () {
      debounceTimer = null;
      forceUpdateNow();
    }, 200);
  }

  // ✅ FIX 3: Sync ALL selects (desktop+mobile) + update flags everywhere + avoid loop
  function attachCurrencySelector() {
    var $sels = $("[data-cc-selector], #ccCurrency");
    if (!$sels.length) return;

    var cur0 = getSavedCurrency() || BASE;
    $sels.val(cur0);
    updateHeaderFlag(cur0);

    var syncing = false;
    $sels.off("change.cc").on("change.cc", function () {
      if (syncing) return;
      syncing = true;

      var cur = String($(this).val() || BASE);

      $sels.val(cur);

      saveCurrency(cur);
      updateHeaderFlag(cur);

      forceUpdateNow();
      setTimeout(forceUpdateNow, 250);
      setTimeout(forceUpdateNow, 900);

      syncing = false;
    });
  }

  function bindVariantAndSubscriptionHooks() {
    $(document).on(
      "change",
      'select[name="id"], input[name="id"], input[name="selling_plan"], select[name="selling_plan"]',
      function () {
        setTimeout(forceUpdateNow, 0);
        setTimeout(forceUpdateNow, 120);
      }
    );

    $(document).on("click", ".subify, [data-subify], .subify-choice-price", function () {
      setTimeout(forceUpdateNow, 0);
      setTimeout(forceUpdateNow, 120);
    });
  }

  function initObserver() {
    observer = new MutationObserver(function () { scheduleUpdate(); });
    var target = document.querySelector('main') || document.body;

    observer.observe(target, {
      childList: true,
      subtree: true
    });
  }

  function init() {
    var saved = getSavedCurrency();

    var currencyPromise = saved
      ? $.Deferred().resolve(saved).promise()
      : getGeoCurrency().then(function (cur) { saveCurrency(cur); return cur; });

    $.when(currencyPromise, getUsdRates())
      .then(function (currency, rates) {
        usdRatesCache = (rates && rates.rates) ? rates : (rates && rates[0] && rates[0].rates ? rates[0] : rates);

        document.documentElement.setAttribute("data-cc-currency", currency);

        updateAllPrices(currency);
        updateHeaderFlag(currency);

        attachCurrencySelector();
        initCurrencyUI();
        bindVariantAndSubscriptionHooks();
        bindCartmaxVariantHook();
        initObserver();
      })
      .fail(function () {
        saveCurrency(BASE);
        document.documentElement.setAttribute("data-cc-currency", BASE);
        updateHeaderFlag(BASE);
      });
  }

  $(document).ready(init);
})(window.jQuery);




(function () {
  function applyFromLabelOnProductCards() {

  document.querySelectorAll(".m-product-card, .m-product-item").forEach(function(card){

    var variantWrapper = card.querySelector("[data-pcard-variant-picker]");
    if (!variantWrapper) return;

    var jsonScript = variantWrapper.querySelector("script[type='application/json']");
    if (!jsonScript) return;

    var variants = [];

    try {
      variants = JSON.parse(jsonScript.textContent.trim());
    } catch(e) {
      return;
    }

    // sirf tab run karo jab 2 ya zyada variants hon
    if (!Array.isArray(variants) || variants.length < 2) return;

    card.querySelectorAll(".cc-price").forEach(function(priceEl){

      if (priceEl.querySelector(".cc-from")) return;

      var from = document.createElement("span");
      from.className = "cc-from";
      from.textContent = "From ";

      priceEl.prepend(from);

    });

  });

}

  // run on load
  document.addEventListener("DOMContentLoaded", applyFromLabelOnProductCards);

  // run again if cards re-render (filters, ajax, infinite scroll)
  new MutationObserver(function () {
    applyFromLabelOnProductCards();
  }).observe(document.body, { childList: true, subtree: true });
})();


